import React from "react";
import { createRoot } from "react-dom/client";
import { ProviderWrapper } from "./app/ProviderWrapper";

const container = document.getElementById("energy-transition-root");
const root = createRoot(container!);
root.render(<ProviderWrapper />);
